import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogModule, MatDialog } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { ButtonComponent, ButtonVariant } from 'src/app/common/components/core/button/button.component';
import { DropdownComponent } from 'src/app/common/components/core/dropdown/dropdown.component';
import { InputComponent } from 'src/app/common/components/core/input/input.component';
import { ConfirmationModalComponent } from 'src/app/common/components/core/modal/confirmation-modal/confirmation-modal.component';
import { InternalCommunicationMessageType } from 'src/app/common/enums/internal-communication-message-type.enum';

@Component({
  selector: 'app-message-editor',
  templateUrl: './message-editor.component.html',
  styleUrls: ['./message-editor.component.scss'],
  standalone: true,
  imports: [FormsModule, CommonModule, ReactiveFormsModule, ButtonComponent, DropdownComponent, InputComponent, MatDialogModule, MatButtonModule, MatIconModule, MatInputModule]
})
export class InnerComponent implements OnInit {
  buttonVariant = ButtonVariant;
  formGroup: FormGroup;
  messageTypeOptions: { id: number; name: string }[] = [];
  messageType: number[] = [];
  messagename: string[] = [];

  constructor(
    public dialogRef: MatDialogRef<InnerComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,  
    private dialog: MatDialog
  ) {
    this.formGroup = new FormGroup({
      title: new FormControl('', Validators.required),
      message: new FormControl('', Validators.required),
      messageTypeControl: new FormControl(InternalCommunicationMessageType.General)
    });
  }

  ngOnInit(): void {
    if (this.data) {
      this.formGroup.patchValue({
        title: this.data.title || '',
        message: this.data.message || '',
        messageTypeControl: this.data.messageTypeControl || InternalCommunicationMessageType.General
      });
    }
    this.messageType = this.data.messageType; 
  }

  resetForm(): void {
    this.formGroup.reset({
      title: '',
      message: '',
      messageTypeControl: InternalCommunicationMessageType.General
    });
  }

  SendasDraft(): void {
    if (this.formGroup.valid) {
      this.dialogRef.close({
        ...this.formGroup.value,
        messageType: this.formGroup.get('messageTypeControl')?.value,
        isDraft: true
      });
    } else {
      this.formGroup.markAllAsTouched();
    }
  }

  Send(): void {
    if (this.formGroup.valid) {
      this.dialogRef.close({
        id: this.data.id ?? 0,
        title: this.formGroup.get('title')?.value,
        message: this.formGroup.get('message')?.value,
        messageType: this.formGroup.get('messageTypeControl')?.value,
        isDraft: false
      });
    } else {
      this.formGroup.markAllAsTouched();
    }
  }

  Cancel(): void {
    if (this.formGroup.dirty) {
      this.openCancelConfirmationDialog();
    } else {
      this.dialogRef.close();
    }
  }

  openCancelConfirmationDialog(): void {
    this.dialog
      .open(ConfirmationModalComponent, {
        data: {
          title: "Discard Changes",
          message: "Are you sure to dischard changes?",
          buttonText: "Discard"
        },
      })
      .afterClosed()
      .subscribe((confirmed) => {
        if (confirmed) {
          this.dialogRef.close();
        }
      });
  }
}